/**
 * 小店管理 初期版本 Service
 * ts version 仅维护
 * js version readonly
 * ! 注意 部分参数类型声明不确切，过渡阶段先忽略
 * TODO 类型维护
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-18 10:26:37
 * ```
 * 以下旧文件头
 * @Author: 肖槿
 * @Date: 2020-06-15 14:49:50
 * @Description: 小店管理请求
 * @LastEditors: 矢车
 * @LastEditTime: 2020-08-13 14:51:16
 * @FilePath: \s2b-admin\src\service\shop.js
 * ```
 */
import axios from './axios';
import { ObjectFilterEmpty } from '@/tslibs/utils/func';
import { Get } from '@/tslibs/utils/request';
// 商家列表
export const getMerchantInfo = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/info/', { params });
};
// 查看订单项最近一次物流
export const getLogisiticsRecent = (order_item_id) => {
    return axios.get(`/api/operators/v1/merchant/internal/order_item/${order_item_id}/logistics/recent/`);
};
// 商家详情
export const getMerchantInfoByUserId = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/info/' + params);
};
/**
 * 小店列表
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-18 10:47:30
 */
export const GetMerchantList = (payload) => Get('/api/operators/v1/merchant/internal/shop/', {
    params: {
        ...ObjectFilterEmpty(payload),
    },
});
// 小店列表
export const getMerchantList = GetMerchantList;
// 添加小店
export const postMerchantList = (data) => {
    return axios.post('/api/operators/v1/merchant/internal/shop/', data);
};
// 修改小店
export const putMerchantList = (data) => {
    return axios.put('/api/operators/v1/merchant/internal/shop/' + data.shop_id, data);
};
// 商家审核认证申请表
export const getMerchantAudit = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/audit/', { params });
};
// 商家审核
export const putMerchantAudit = (data) => {
    const p = `${data.id}/`;
    delete data.id;
    return axios.put(`/api/operators/v1/merchant/internal/merchant/audit/${p}`, data);
};
// 商家审核历史
export const getMerchantHistory = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/audit/history/', { params });
};
// 商家审核历史详情
export const getMerchantHistoryInfo = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/audit/history/' + params + '/');
};
// 商品列表
export const getExternalSpuInfo = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/spu_info/', { params });
};
// 商品详情
export const getExternalSpuInfoById = (params) => {
    return axios.get(`/api/operators/v1/merchant/internal/spu_info/${params}/`);
};
// 商品详情客服、小店、售价、市场价
export const getPutOnShelves = (params) => {
    return axios.get(`/api/operators/v1/merchant/internal/spu_info/${params}/put_on_shelves/`);
};
// 商品初审/撤销审核
export const putSpuInfoAudit = (data) => {
    const p = data.spu_id;
    delete data.spu_id;
    return axios.put(`/api/operators/v1/merchant/internal/spu_info/${p}/audit/`, data);
};
// 商品详情客服、小店、售价、市场价
export const putPutOnShelves = (data) => {
    const p = data.spu_id;
    delete data.spu_id;
    return axios.put(`/api/operators/v1/merchant/internal/spu_info/${p}/put_on_shelves/`, data);
};
// 价格变更审核表
export const getSkuSupplyPrice = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/sku_supply_price_audit_group/', { params });
};
// 库存变更审核表
export const getSkuStockAudit = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/sku_stock_audit_group/', { params });
};
// 库存变更审核详情
export const getSkuSupplyPriceInfo = (params) => {
    return axios.get(`/api/operators/v1/merchant/internal/sku_supply_price_audit_group/${params.audit_group_id}/`, { params });
};
// 价格变更审核详情
export const getSkuSupplyStockInfo = (params) => {
    return axios.get(`/api/operators/v1/merchant/internal/sku_stock_audit_group/${params.audit_group_id}/`, { params });
};
// 价格变更审核
export const putSkuSupplyPrice = (data) => {
    const p = data.audit_group_id;
    delete data.audit_group_id;
    return axios.put(`/api/operators/v1/merchant/internal/sku_supply_price_audit_group/${p}/audit/`, data);
};
// 库存变更审核
export const putSkuSupplyStock = (data) => {
    const p = data.audit_group_id;
    delete data.audit_group_id;
    return axios.put(`/api/operators/v1/merchant/internal/sku_stock_audit_group/${p}/audit/`, data);
};
// 类目
export const getCategory = (params) => {
    return axios.get(`/api/operators/v1/merchant/internal/category/${params}/`);
};
// 订单管理列表
export const getOrderList = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/order/', { params });
};
// 小店商家后台-商家账户列表
export const getAccountList = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/merchant/account/', { params });
};
// 小店商家后台-商家账户列表-确认保证金
export const confirmMargin = (data) => {
    const p = data.id;
    delete data.id;
    return axios.put(`/api/operators/v1/merchant/internal/merchant/account/deposit/${p}/`, data);
};
// 导出订单列表
export const getOrderExport = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/order/export/', { params });
};
// 上传结算单
export const postPreSettlement = (data) => {
    return axios.post('/api/operators/v1/merchant/internal/finance/pre_settlement/', data);
};
// 长轮询获取结算单的上传结果
export const postUploaded = (id) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/pre_settlement/uploaded/${id}/`);
};
// 刷新上传的结算单
export const getPreSettlement = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/finance/pre_settlement/', { params });
};
// 上传的结算单明细
export const getPreSettlementId = (id, params) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/pre_settlement/${id}/`, { params });
};
// 确认上传的结算单
export const putPreSettlement = (data, options = {}) => {
    return axios.put('/api/operators/v1/merchant/internal/finance/pre_settlement/', data, options);
};
// 结算列表
export const settlementList = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/finance/settlement/', { params });
};
// 结算列表 - 明细
export const getSettlementId = (id, params) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/settlement/${id}/`, { params });
};
// 账户管理列表(右边2个tab页)
export const getWithdrawDepositApply = (params) => {
    return axios.get('/api/operators/v1/merchant/internal/finance/settlement/withdraw_deposit_apply/', { params });
};
// 账户管理 - 账户详情
export const getBalanceDetails = (id, params) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/account/balance_details/${id}/`, {
        params,
    });
};
// 提现申请详情
export const getWithdrawDepositApplyDetails = (id, params) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/settlement/withdraw_deposit_apply/${id}/`, { params });
};
// 审核提现申请
export const putWithdrawDepositApply = (id, data) => {
    return axios.put(`/api/operators/v1/merchant/internal/finance/settlement/withdraw_deposit_apply/audit/${id}/`, data);
};
// 提现申请打款(完成打款)
export const postRemit = (id, data) => {
    return axios.post(`/api/operators/v1/merchant/internal/finance/settlement/withdraw_deposit_apply/remit/${id}/`, data);
};
// 导出结算单
export const getSettleExport = (id, options = {}) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/settlement/export/${id}/`, options);
};
export const getSettleFile = (id) => {
    return axios.get(`/api/operators/v1/merchant/internal/finance/pre_settlement/file/${id}/`);
};
//# sourceMappingURL=shop.js.map